import { useCallback, useRef, useState } from 'react';
import type { NotifyInput } from '../app/hooks/useConversions';

export interface Toast extends NotifyInput {
  id: number;
}

const AUTO_DISMISS_MS = 4000;

/** 统一的轻量提示：替代 alert，不阻塞交互。 */
export function useToasts() {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const sequence = useRef(0);

  const dismiss = useCallback((id: number) => {
    setToasts((current) => current.filter((toast) => toast.id !== id));
  }, []);

  const notify = useCallback(
    (input: NotifyInput) => {
      sequence.current += 1;
      const toast: Toast = { ...input, id: sequence.current };
      setToasts((current) => [...current.slice(-3), toast]);
      setTimeout(() => dismiss(toast.id), AUTO_DISMISS_MS);
    },
    [dismiss],
  );

  return { toasts, notify, dismiss };
}

export function ToastStack({ toasts, onDismiss }: { toasts: Toast[]; onDismiss: (id: number) => void }) {
  if (toasts.length === 0) return null;
  return (
    <div className="toast-stack" role="status" aria-live="polite">
      {toasts.map((toast) => (
        <button
          type="button"
          key={toast.id}
          className="toast"
          data-tone={toast.tone}
          onClick={() => onDismiss(toast.id)}
          title="点击关闭"
        >
          <div>
            <div className="title">{toast.title}</div>
            {toast.description ? <div className="desc">{toast.description}</div> : null}
          </div>
        </button>
      ))}
    </div>
  );
}
